import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { feedFiltersVar } from 'modulesCommon/store'

import { useMatchNotifications } from './useMatchNotification'
import { FEED_FILTER_STORAGE_NAME } from 'shared/consts/filter'
import { formatMatchSearch } from '../utils/notifications'
import { useDeleteNotification } from './useDeleteNotifications'
import { useTags } from '../../Tags/useTags'
import { useURLBuilder } from 'shared/hooks'

import { Tag } from 'shared/__gql-types'
import { useReactiveVar } from '@apollo/client'

export const useNotificationActions = () => {
  const { getProjectPageUrl } = useURLBuilder()

  const navigate = useNavigate()
  const { getTagByName } = useTags({ labelId: '', spaceId: '' })
  const feedFilters = useReactiveVar(feedFiltersVar)
  const { openMatchedNotification } = useMatchNotifications()
  const { onDeleteNotifications } = useDeleteNotification()

  const onTagNavigation = useCallback((tag: Tag) => {
    const feedFilterValues = {
      ...feedFilters,
      tags: [{ id: tag.id, label: tag.label, order_number: tag?.order_number }]
    }

    feedFiltersVar(feedFilterValues)
    localStorage.setItem(FEED_FILTER_STORAGE_NAME, JSON.stringify(feedFilterValues))
    navigate('/feed')
  }, [navigate, feedFilters])

  const onClickNotification = useCallback((notification) => () => {
    const type = notification.notification_type
    if (type === 'ProductMatchGcdm') {
      return openMatchedNotification(formatMatchSearch(notification))
    }

    const tag = getTagByName(notification.notification_type)

    if (type === 'GH_GLOBAL_PROJECT') {
      navigate(getProjectPageUrl(notification.campaign.id, true))
      onDeleteNotifications(notification.ids)
    } else if (type === 'GH_SUCCESS_STORY') {
      // TODO: the name of the tab --- remove when change logic of the tab
      navigate(getProjectPageUrl(notification.story.campaign.parent_id, true), { state: { tab: 'successStories'} })
    } else if (type === 'GH_GLOBAL_STORY') {
      navigate(getProjectPageUrl(notification.story.campaign_id, true))
    } else if (tag) {
      onTagNavigation(tag)
    } else if (type === 'UnreadArgument') {
      navigate(getProjectPageUrl(notification.story.campaign_id))
    }
  }, [getTagByName, openMatchedNotification, navigate, getProjectPageUrl, onDeleteNotifications, onTagNavigation])

  return {
    onClickNotification,
    onDeleteNotifications
  }
}
